<template>
  <LayoutActionCard
    :title="title"
    :subtitle="subtitle"
    :is-configured="isConfigured"
    :is-configure-active="isConfigureActive"
    :selected="selected"
    @delete="$emit('delete')"
    @configure="handleConfigure"
  >
    <template #icon>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14 2H6C4.9 2 4.01 2.9 4.01 4L4 20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20ZM9 13.5L10.41 14.91L12 13.33V19H14V13.33L15.59 14.91L17 13.5L12.5 9L9 13.5Z" fill="#FFFFFF"/>
      </svg>
    </template>

    <template #content>
      <!-- Not Configured State -->
      <div v-if="!isConfigured" class="action-content">
        <!-- Warning Message -->
        <!-- <div class="warning-message">
          <img src="@/assets/MyWorkBench/Workflow/warning_icon_triangel.svg" style="width: 20px; height: 20px; margin-right: 4px;" />
          <span class="warning-text">Required fields cannot be empty.</span>
        </div> -->

        <!-- Task Title Field -->
        <!-- <div class="form-field">
          <label class="field-label">Task Title</label>
          <input
            v-model="localFormData.title"
            type="text"
            class="task-title-input"
            placeholder="Enter task title"
            @input="updateSharedData"
          />
        </div> -->

        <!-- Task Description Field -->
        <!-- <div class="form-field">
          <label class="field-label">
            Task Description <span class="required-mark">(Required)</span>
          </label>
          <TextareaWithClear
            v-model="localFormData.description"
            placeholder="Describe the task"
            :max-length="1000"
            :rows="4"
            @update:modelValue="updateSharedData"
          />
        </div> -->

        <!-- Assign to Field -->
        <!-- <div class="form-field">
          <label class="field-label">
            Assign to <span class="required-mark">(Required)</span>
          </label>
          <div class="assign-to-row">
            <el-select
              v-model="localFormData.assigneeType"
              placeholder="Please select"
              class="assignee-type-select"
              size="large"
              @change="handleAssigneeTypeChange"
            >
              <el-option label="Patient" value="patient" />
              <el-option label="Team Member" value="team" />
            </el-select>
            <AssigneeDropdown
              ref="assigneeDropdown"
              v-model="localFormData.assigneeId"
              :initial-value="localFormData.assigneeName"
              :options="assigneeOptions"
              :label-field-name="'name'"
              :value-field-name="'id'"
              :placeholder="assigneeType === 'patient' ? 'Search patient' : 'Search team member'"
              :loading="isLoadingAssignees"
              :can-scroll-fetch-more="assigneeType === 'patient'"
              height="40px"
              padding="8px 12px"
              class="assignee-dropdown"
              @search="handleAssigneeSearch"
              @update:modelValue="handleAssigneeSelect"
              @scroll-bottom="handleScrollBottom"
            />
          </div>
        </div> -->

        <!-- Due by Field -->
        <!-- <div class="form-field">
          <label class="field-label">
            Due by <span class="required-mark">(Required)</span>
          </label>
          <div class="due-by-row">
            <el-date-picker
              v-model="localFormData.dueDate"
              type="date"
              placeholder="Enter Date"
              class="w-1/2"
              style="width: 160px; border: 1px solid #C9C9C9;border-radius: 4px;"
              size="large"
              @change="updateSharedData"
            />
            <el-time-select
              v-model="localFormData.dueTime"
              start="06:00"
              step="00:30"
              end="23:30"
              placeholder="9:00 AM"
              prefix-icon=""
              format="hh:mm A"
              class="w-1/2"
              size="large"
              @change="updateSharedData"
            />
          </div>
        </div> -->
              </div>

      <!-- Configured State -->
      <div v-else class="action-content action-content--configured">
        <div class="config-row">
          <span class="config-label">Task Title: </span>
          <span class="config-value">{{ displayTaskTemplate }}</span>
        </div>
        <div class="config-row">
          <span class="config-label">Task Description: </span>
          <span class="config-value">{{ displayTaskDescription }}</span>
        </div>
        <div class="config-row">
          <span class="config-label">Assignee: </span>
          <span class="config-value">{{ displayAssignee }}</span>
        </div>
        <div class="config-row">
          <span class="config-label">Due by: </span>
          <span class="config-value">{{ displayDueBy }}</span>
        </div>
              </div>
    </template>
  </LayoutActionCard>
</template>

<script>
import LayoutActionCard from './LayoutActionCard.vue';
import TextareaWithClear from '@/components/workflow/TextareaWithClear.vue';
import AssigneeDropdown from '@/components/workflow/AssigneeDropdown.vue';
import { getPatientListApi } from '@/api/patientList';
import { getCustomersByClinicIdApi } from '@/api/setting';
import { mapState } from 'vuex';

export default {
  name: 'AssignTask',
  components: {
    LayoutActionCard,
    TextareaWithClear,
    AssigneeDropdown
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete', 'configure'],
  data() {
    return {
      localFormData: {
        title: this.data.title || '',
        description: this.data.description || '',
        assigneeType: this.data.assigneeType || '',
        assigneeId: this.data.assigneeId || '',
        assigneeName: this.data.assigneeName || '',
        dueDate: this.data.dueDate || '',
        dueTime: this.data.dueTime || ''
      },
      patientPage: 1,
      hasMorePatients: true,
      searchDebounceTimer: null
    };
  },
  computed: {
    ...mapState('login', ['userInfo']),
    ...mapState('workbench/providers', ['providers']),
    ...mapState('workbench/workflow', {
      storePatientSearchTerm: 'patientSearchTerm',
      storeSearchedPatients: 'searchedPatients',
      storeIsLoadingPatients: 'isLoadingPatients'
    }),
    assigneeType() {
      return this.localFormData.assigneeType;
    },
    title() {
      return 'Assign Task';
    },
    subtitle() {
      return 'Assign a task to the patient or a clinic team member';
    },
    // Computed options based on assignee type
    assigneeOptions() {
      if (this.localFormData.assigneeType === 'patient') {
        return this.storeSearchedPatients;
      } else if (this.localFormData.assigneeType === 'team') {
        return this.teamMemberOptions;
      }
      return [];
    },
    // Team member options (filtered locally)
    teamMemberOptions() {
      return this.providers.map((provider, index) => ({
        id: provider.customer_id,
        name: `${provider.customer_first_name || ''} ${provider.customer_last_name || ''}`.trim() || provider.customer_name,
        checked: false,
        checkboxStatus: 'uncheck',
        index: index
      }));
    },
    // Loading state
    isLoadingAssignees() {
      return this.localFormData.assigneeType === 'patient' 
        ? this.storeIsLoadingPatients 
        : false;
    },
    // Use savedData for display when available
    displayData() {
      return (this.data && this.data.savedData) ? this.data.savedData : this.data;
    },
    isConfigured() {
      return Boolean(this.displayData && this.displayData.configured);
    },
    isConfigureActive() {
      // Configure is active when all required fields have content
      return Boolean(
        this.localFormData.description && this.localFormData.description.trim().length > 0 &&
        this.localFormData.assigneeName && this.localFormData.assigneeName.trim().length > 0 &&
        this.localFormData.dueDate
      );
    },
    displayTaskTemplate() {
      if (this.displayData && this.displayData.title) {
        return this.displayData.title;
      }
      return 'N/A';
    },
    displayTaskDescription() {
      if (this.displayData && this.displayData.description) {
        return this.displayData.description;
      }
      return 'N/A';
    },
    displayAssignee() {
      if (this.displayData && this.displayData.assigneeName) {
        return this.displayData.assigneeName;
      }
      return 'N/A';
    },
    displayDueBy() {
      if (this.displayData && this.displayData.dueDate && this.displayData.dueTime) {
        // Parse the date from el-date-picker (Date object with timezone)
        // e.g., 'Fri Jan 23 2026 00:00:00 GMT-0800 (Pacific Standard Time)'
        let date = new Date(this.displayData.dueDate);
        
        // Parse the time from el-time-select (string like "07:30" or "9:00 AM")
        let timeStr = this.displayData.dueTime;
        let hours = 0;
        let minutes = 0;
        
        // Check if time is in 12-hour format (with AM/PM)
        if (timeStr.includes('AM') || timeStr.includes('PM')) {
          const isPM = timeStr.includes('PM');
          const timeParts = timeStr.replace(/AM|PM/g, '').trim().split(':');
          hours = parseInt(timeParts[0]);
          minutes = parseInt(timeParts[1] || 0);
          
          // Convert to 24-hour format
          if (isPM && hours !== 12) {
            hours += 12;
          } else if (!isPM && hours === 12) {
            hours = 0;
          }
        } else {
          // 24-hour format (e.g., "07:30")
          const timeParts = timeStr.split(':');
          hours = parseInt(timeParts[0]);
          minutes = parseInt(timeParts[1] || 0);
        }
        
        // Add the time to the date by adding milliseconds (avoids date rollback issues)
        const timeInMs = (hours * 60 * 60 * 1000) + (minutes * 60 * 1000);
        const combinedDateTime = new Date(date.getTime() + timeInMs);
        
        // Convert to local timezone string, then parse back to Date object
        // This ensures the date/time is displayed in the user's current timezone
        const localTimeString = combinedDateTime.toLocaleString('en-US', { 
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone 
        });
        const localDate = new Date(localTimeString);
        
        // Format as MM-DD-YYYY HH:MM AM/PM using local time
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        const year = localDate.getFullYear();
        
        let displayHours = localDate.getHours();
        const displayMinutes = String(localDate.getMinutes()).padStart(2, '0');
        const ampm = displayHours >= 12 ? 'PM' : 'AM';
        
        displayHours = displayHours % 12;
        displayHours = displayHours ? displayHours : 12; // 0 should be 12
        
        return `${month}-${day}-${year} ${displayHours}:${displayMinutes} ${ampm}`;
      }
      return 'N/A';
    }
  },
  watch: {
    'data.title': {
      handler(newVal) {
        if (newVal !== this.localFormData.title) {
          this.localFormData.title = newVal || '';
        }
      },
      immediate: true
    },
    'data.description': {
      handler(newVal) {
        if (newVal !== this.localFormData.description) {
          this.localFormData.description = newVal || '';
        }
      },
      immediate: true
    },
    'data.assigneeType': {
      handler(newVal) {
        if (newVal !== this.localFormData.assigneeType) {
          this.localFormData.assigneeType = newVal || '';
        }
      },
      immediate: true
    },
    'data.assigneeName': {
      handler(newVal) {
        if (newVal !== this.localFormData.assigneeName) {
          this.localFormData.assigneeName = newVal || '';
        }
      },
      immediate: true
    },
    'data.assigneeId': {
      handler(newVal) {
        if (newVal !== this.localFormData.assigneeId) {
          this.localFormData.assigneeId = newVal || '';
        }
      },
      immediate: true
    },
    'data.dueDate': {
      handler(newVal) {
        if (newVal !== this.localFormData.dueDate) {
          this.localFormData.dueDate = newVal || '';
        }
      },
      immediate: true
    },
    'data.dueTime': {
      handler(newVal) {
        if (newVal !== this.localFormData.dueTime) {
          this.localFormData.dueTime = newVal || '';
        }
      },
      immediate: true
    }
  },
  mounted() {
    // Initialize local form data from props if available
    if (this.data && this.data.title) {
      this.localFormData.title = this.data.title;
    }
    if (this.data && this.data.description) {
      this.localFormData.description = this.data.description;
    }
    if (this.data && this.data.assigneeType) {
      this.localFormData.assigneeType = this.data.assigneeType;
    }
    if (this.data && this.data.assigneeId) {
      this.localFormData.assigneeId = this.data.assigneeId;
    }
    if (this.data && this.data.assigneeName) {
      this.localFormData.assigneeName = this.data.assigneeName;
    }
    if (this.data && this.data.dueDate) {
      this.localFormData.dueDate = this.data.dueDate;
    }
    if (this.data && this.data.dueTime) {
      this.localFormData.dueTime = this.data.dueTime;
    }
  },
  beforeUnmount() {
    // Clear debounce timer on component cleanup
    if (this.searchDebounceTimer) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
  },
  methods: {
    handleConfigure() {
      this.$emit('configure', {
        title: this.localFormData.title,
        description: this.localFormData.description,
        assigneeType: this.localFormData.assigneeType,
        assigneeName: this.localFormData.assigneeName,
        dueDate: this.localFormData.dueDate,
        dueTime: this.localFormData.dueTime
      });
    },
    async handleAssigneeTypeChange() {
      // Clear assignee selection when type changes
      this.localFormData.assigneeId = '';
      this.localFormData.assigneeName = '';
      
      // Clear the dropdown input
      if (this.$refs.assigneeDropdown) {
        this.$refs.assigneeDropdown.clearInput();
      }
      
      // Clear patient search in store
      this.$store.dispatch('workbench/workflow/clearPatientSearch');
      
      this.updateSharedData();
      
      // Load team members from store if switching to team
      if (this.localFormData.assigneeType === 'team') {
        await this.loadTeamMembersFromStore();
      }
    },
    
    async handleAssigneeSearch(searchTerm) {
      // Update store search term (syncs with editor)
      this.$store.dispatch('workbench/workflow/setPatientSearchTerm', searchTerm);
      
      if (this.localFormData.assigneeType === 'patient') {
        // Clear existing debounce timer
        if (this.searchDebounceTimer) {
          clearTimeout(this.searchDebounceTimer);
        }
        
        // Debounce API call by 500ms
        this.searchDebounceTimer = setTimeout(async () => {
          this.patientPage = 1;
          this.hasMorePatients = true;
          await this.searchPatients(searchTerm);
        }, 500);
      } else if (this.localFormData.assigneeType === 'team') {
        this.filterTeamMembers(searchTerm);
      }
    },
    
    async handleScrollBottom() {
      if (this.localFormData.assigneeType === 'patient' && this.hasMorePatients && !this.isLoadingAssignees) {
        this.patientPage++;
        await this.searchPatients(this.$refs.assigneeDropdown?.searchTerm || '', true);
      }
    },
    
    async searchPatients(searchTerm, append = false) {
      try {
        this.$store.dispatch('workbench/workflow/setLoadingPatients', true);
        
        const response = await getPatientListApi({
          search_patient_field: searchTerm || '',
          search_patient_type: 'patient_name',
          page: String(this.patientPage),
          perPage: '20'
        });
        
        if (response && response.patients && Array.isArray(response.patients)) {
          const newPatients = response.patients.map((patient, index) => {
            // Build full name: first middle last
            const nameParts = [
              patient.patient_first_name || '',
              patient.patient_middle_name || '',
              patient.patient_last_name || ''
            ].filter(part => part.trim().length > 0);
            
            return {
              id: patient.patient_id,
              name: nameParts.join(' '),
              checked: false,
              checkboxStatus: 'uncheck',
              index: append ? this.storeSearchedPatients.length + index : index
            };
          });
          
          // Update store (syncs with editor)
          if (append) {
            this.$store.dispatch('workbench/workflow/appendSearchedPatients', newPatients);
          } else {
            this.$store.dispatch('workbench/workflow/setSearchedPatients', newPatients);
          }
          
          // Check if there are more patients
          this.hasMorePatients = response.patients.length === 20;
        }
      } catch (error) {
        console.error('Error searching patients:', error);
      } finally {
        this.$store.dispatch('workbench/workflow/setLoadingPatients', false);
      }
    },
    
    async loadTeamMembersFromStore() {
      try {
        const clinicId = this.userInfo?.clinic_id;
        if (!clinicId) {
          console.error('No clinic ID found');
          return;
        }
        
        // Check if providers exist in store
        if (!this.providers || this.providers.length === 0) {
          // Fetch from API if not in store
          await this.$store.dispatch('workbench/providers/fetchProviders', clinicId);
        }
      } catch (error) {
        console.error('Error loading team members:', error);
      }
    },
    
    filterTeamMembers(searchTerm) {
      // Team members are filtered locally, no store needed
      // This is handled by the component's local computed property
    },
    
    handleAssigneeSelect(assigneeId) {
      if (assigneeId) {
        const options = this.localFormData.assigneeType === 'patient' 
          ? this.storeSearchedPatients 
          : this.teamMemberOptions;
        const selected = options.find(opt => opt.id === assigneeId);
        if (selected) {
          this.localFormData.assigneeId = selected.id;
          this.localFormData.assigneeName = selected.name;
        }
      } else {
        this.localFormData.assigneeId = '';
        this.localFormData.assigneeName = '';
      }
      this.updateSharedData();
    },
    
    updateSharedData() {
      // Update the shared data instance directly
      this.data.title = this.localFormData.title;
      this.data.description = this.localFormData.description;
      this.data.assigneeType = this.localFormData.assigneeType;
      this.data.assigneeId = this.localFormData.assigneeId || null;
      this.data.assigneeName = this.localFormData.assigneeName || '';
      this.data.dueDate = this.localFormData.dueDate;
      this.data.dueTime = this.localFormData.dueTime;
    }
  }
};
</script>

<style scoped>
.action-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

/* Warning Message */
.warning-message {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 0;
}

.warning-text {
  flex: 1;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
}

/* Form Field */
.form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.field-label {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #4A4A4A;
  display: flex;
  align-items: center;
}

.required-mark {
  color: #D10000;
  margin-left: 4px;
}

/* Select Fields */
.task-template-select,
.assignee-type-select,
.due-time-select {
  width: 100%;
  height: 42px;
}

/* Task Title Input */
.task-title-input {
  width: 100%;
  height: 40px;
  padding: 8px 12px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
  outline: none;
}

.task-title-input::placeholder {
  color: #999;
}

.task-title-input:focus {
  border-color: #004879;
}

/* Assign to Row */
.assign-to-row {
  display: flex;
  gap: 8px;
  width: 100%;
}

.assignee-type-select {
  flex: 1;
}

.assignee-dropdown {
  flex: 1;
}

/* Due by Row */
.due-by-row {
  display: flex;
  gap: 8px;
  width: 100%;
}

.due-date-input {
  flex: 1;
  height: 40px;
  padding: 8px 12px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  color: #333;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  border-radius: 4px;
  outline: none;
}

.due-date-input::placeholder {
  color: #999;
}

.due-date-input:focus {
  border-color: #004879;
}

.due-time-select {
  flex: 0 0 auto;
  width: 140px;
}

/* Configured State */
.config-row {
  gap: 0;
  margin-bottom: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  display: -webkit-box;
  line-clamp: 5;
  overflow: hidden;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}

.config-row:last-child {
  margin-bottom: 0;
}

.config-label {
  font-weight: 700;
  color: #374957;
}

.config-value {
  font-weight: 400;
  color: #333;
}

</style>
